// Cursor-based "load more" control for server-side pagination.
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from './ui';

export function LoadMore({
  hasMore,
  loading,
  onLoadMore,
}: {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}) {
  const { t } = useTranslation();
  if (!hasMore) return null;
  return (
    <div className="pagination">
      <Button variant="secondary" onClick={onLoadMore} disabled={loading}>
        {loading ? <Spinner /> : null}
        {t('common.loadMore')}
      </Button>
    </div>
  );
}
